import React, { createElement, useEffect, useState } from 'react';
import { Radio, Space, Form, Col } from 'antd';
import { generateRules } from '../../../utils/index';
import './index.scss';
import { getDynamicTableDataByColumn, getPersonnelInformation, listChartViewField, previewData, } from '../../../api/form';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormRadio = (props, ref) => {
    const { isNecessary, verifytext, title, __id, rules, direction, status, span, column, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            if (props?.options?.type === '自定义') {
                setOptions(props?.options?.options);
            }
            else if (props?.options?.type === '关联表单') {
                if (props.options?.reportId && props.options?.columnName) {
                    const params = {
                        reportId: props.options?.reportId,
                        columnName: props.options?.columnName,
                    };
                    getDynamicTableDataByColumn(params).then((res) => {
                        if (res?.code === 200) {
                            setOptions(res.data.map((e) => ({ label: e[params.columnName], value: e[params.columnName] })));
                        }
                    });
                }
            }
            else if (props?.options?.type === '关联人员') {
                getPersonnelInformation().then((res) => {
                    setOptions(res.rows.map((e) => ({ label: e.nickName, value: e.userId })));
                });
            }
            else if (props?.options?.type === '数据模型') {
                if (props?.options?.modelId && props?.options?.labelId) {
                    previewData(props?.options?.modelId).then((res) => {
                        let temp = [];
                        res?.data?.data?.data.forEach((item) => {
                            temp.push({
                                label: item[props?.options?.labelId],
                                value: item[props?.options?.labelId],
                            });
                        });
                        setOptions(temp);
                    });
                }
            }
            else if (props?.options?.type === '数据集' && props?.options?.datesetId) {
                listChartViewField(props?.options?.datesetId).then((res) => {
                    setOptions([...res.data.dimensionList, ...res.data.quotaList].map((item) => ({
                        label: item.name,
                        value: item.fieldShortName,
                    })));
                });
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('单选选项初始化失败,检查配置或更新组件');
        }
    }, [props?.options]);
    const [rule, setRule] = useState([]);
    useEffect(() => {
        try {
            setRule(generateRules(rules));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '单选', name: __id || props.componentId, rules: rule },
                createElement(Radio.Group, Object.assign({ disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other),
                    createElement(Space, { direction: direction }, options.map((e) => (createElement(Radio, { value: e.value }, e.label)))))))))));
};
export default React.forwardRef(FormRadio);
